
{
  "fr": {
    "zoneInputImage": {
      "placeholder": "Importer une image",
      "placeholderDebug": "Ajouter une image ou générer par IA",
      "qualityWarning": "Votre fichier semble de qualité insuffisante et risque d'être pixelisé à l'impression."
    }
  }
}
